import { useState } from 'react'
import { MIN_PAGINATION_SIZE } from 'constants/queries'
import { CustomersRequest } from 'types/customers'
import { CustomerModel } from '../helpers/types'

export const useCustomersQueryParams = (customerModel: CustomerModel) => {
  const initialQueryParams: CustomersRequest = {
    size: MIN_PAGINATION_SIZE,
    page: 0,
    search: '',
    filters: { models: [customerModel] },
  }

  const [queryParams, setQueryParams] = useState<CustomersRequest>(initialQueryParams)

  const onChangePage = (page: number) => {
    setQueryParams(current => ({ ...current, page }))
  }

  const onChangeRowsPerPage = (size: number) => {
    setQueryParams(current => ({ ...current, size, page: 0 }))
  }

  const onChangeSearchAndFilter = (updatedSearchAndFilter: CustomersRequest) => {
    setQueryParams(current => ({ ...current, ...updatedSearchAndFilter, page: 0 }))
  }

  return { queryParams, onChangePage, onChangeRowsPerPage, onChangeSearchAndFilter }
}
